import _debounce from 'lodash/debounce';

const debouncedFunction = (func) =>
  _debounce(func, 1000, { leading: true, trailing: false });

export default debouncedFunction;
